import { render, staticRenderFns } from "./FastShopping.vue?vue&type=template&id=9ca90ca6&scoped=true"
import script from "./FastShopping.vue?vue&type=script&lang=js"
export * from "./FastShopping.vue?vue&type=script&lang=js"
import style0 from "./FastShopping.vue?vue&type=style&index=0&id=9ca90ca6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca90ca6",
  null
  
)

export default component.exports